import { render, staticRenderFns } from "./HotTags.vue?vue&type=template&id=413436ae&scoped=true&"
import script from "./HotTags.vue?vue&type=script&lang=js&"
export * from "./HotTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413436ae",
  null
  
)

export default component.exports